import React from 'react';
import { SlideWrapper, GlassCard, SectionLabel } from './SharedComponents';

// ============ SLIDE 21: WHAT IS A NODE ============
export const SalesNodeSlide = ({ slide }) => {
  const colors = ['#0068ff', '#8b5cf6', '#06b6d4', '#22c55e'];
  const icons = [
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2" /><circle cx="17" cy="8" r="1" fill="currentColor" /><circle cx="17" cy="16" r="1" fill="currentColor" /></svg>,
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" /></svg>,
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" /></svg>,
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
  ];
  return (
    <SlideWrapper slide={slide} background={
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#030308] via-[#060612] to-[#030308]" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-[#0068ff] opacity-[0.07] blur-[180px] rounded-full" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#8b5cf6] opacity-[0.04] blur-[120px] rounded-full" />
      </div>
    }>
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
        <SectionLabel delay={0}>The Product</SectionLabel>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mt-5 mb-3 animate-slide-up">{slide.title}</h2>
        <p className="text-white/40 text-base text-center max-w-3xl mb-10 animate-fade-in" style={{ animationDelay: '0.1s' }}>{slide.subtitle}</p>
        <div className="grid grid-cols-2 gap-5 w-full max-w-4xl">
          {slide.functions.map((fn, idx) => (
            <GlassCard key={idx} delay={0.2 + idx * 0.1} className="p-6 flex items-start gap-4 hover:scale-[1.02] transition-transform duration-300" style={{ borderColor: `${colors[idx]}20`, background: `linear-gradient(135deg, ${colors[idx]}08, transparent)` }}>
              <div className="w-12 h-12 rounded-xl shrink-0 flex items-center justify-center" style={{ background: `${colors[idx]}15`, color: colors[idx] }}>{icons[idx]}</div>
              <div>
                <h3 className="text-white font-bold text-base mb-1">{fn.name}</h3>
                <p className="text-white/40 text-sm leading-relaxed">{fn.description}</p>
              </div>
            </GlassCard>
          ))}
        </div>
      </div>
    </SlideWrapper>
  );
};

// ============ SLIDE 22: DEMAND GROWTH ============
export const SalesDemandSlide = ({ slide }) => {
  const colors = ['#8b5cf6', '#0068ff', '#f43f5e', '#06b6d4', '#22c55e', '#f59e0b'];
  return (
    <SlideWrapper slide={slide} background={
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#030308] via-[#060610] to-[#030308]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[700px] bg-[#0068ff] opacity-[0.06] blur-[180px] rounded-full" />
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#22c55e] opacity-[0.03] blur-[120px] rounded-full" />
      </div>
    }>
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
        <SectionLabel color="#22c55e" delay={0}>Market Growth</SectionLabel>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mt-5 mb-3 animate-slide-up">{slide.title}</h2>
        <p className="text-white/40 text-lg mb-10 animate-fade-in" style={{ animationDelay: '0.1s' }}>{slide.subtitle}</p>
        <div className="grid grid-cols-3 gap-4 w-full max-w-4xl mb-8">
          {slide.metrics.map((m, idx) => (
            <GlassCard key={idx} delay={0.2 + idx * 0.07} className="p-5 text-center" style={{ borderColor: `${colors[idx]}20` }}>
              <div className="text-3xl font-black mb-1" style={{ color: colors[idx] }}>{m.value}</div>
              <div className="text-white/40 text-sm">{m.label}</div>
            </GlassCard>
          ))}
        </div>
        <GlassCard delay={0.6} className="px-8 py-3 text-center max-w-2xl" style={{ borderColor: '#0068ff20' }}>
          <p className="text-white/50 text-sm">{slide.closing}</p>
        </GlassCard>
      </div>
    </SlideWrapper>
  );
};

// ============ SLIDE 23: REWARDS ============
export const SalesRewardsSlide = ({ slide }) => (
  <SlideWrapper slide={slide} background={
    <div className="fixed inset-0 z-0">
      <div className="absolute inset-0 bg-gradient-to-b from-[#030308] via-[#040a10] to-[#030308]" />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-[#22c55e] opacity-[0.05] blur-[180px] rounded-full" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#0068ff] opacity-[0.04] blur-[120px] rounded-full" />
    </div>
  }>
    <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
      <SectionLabel color="#22c55e" delay={0}>Revenue Model</SectionLabel>
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mt-5 mb-3 animate-slide-up">{slide.title}</h2>
      <p className="text-white/40 text-lg mb-8 animate-fade-in" style={{ animationDelay: '0.1s' }}>{slide.subtitle}</p>
      <div className="flex items-stretch gap-6 w-full max-w-4xl mb-8">
        <GlassCard delay={0.2} className="flex-1 p-6" style={{ borderColor: '#0068ff20' }}>
          <h3 className="text-[#0068ff] font-bold text-sm uppercase tracking-wider mb-4">Network Growth</h3>
          <div className="space-y-3">
            {slide.growth.map((g, i) => (
              <div key={i} className="flex items-center gap-3">
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-[#0068ff] shrink-0" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>
                <span className="text-white/60 text-sm">{g}</span>
              </div>
            ))}
          </div>
        </GlassCard>
        <GlassCard delay={0.3} className="flex-1 p-6" style={{ borderColor: '#22c55e20', background: 'linear-gradient(135deg, rgba(34,197,94,0.06), transparent)' }}>
          <h3 className="text-[#22c55e] font-bold text-sm uppercase tracking-wider mb-4">Node Owners Earn For</h3>
          <div className="space-y-3">
            {slide.rewards.map((r, i) => (
              <div key={i} className="flex items-center gap-3">
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-[#22c55e] shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 13l4 4L19 7" /></svg>
                <span className="text-white/60 text-sm">{r}</span>
              </div>
            ))}
          </div>
        </GlassCard>
      </div>
      <GlassCard delay={0.5} className="px-8 py-3 text-center max-w-2xl" style={{ borderColor: '#22c55e20' }}>
        <span className="text-[#22c55e] font-semibold text-sm">{slide.closing}</span>
      </GlassCard>
    </div>
  </SlideWrapper>
);

// ============ SLIDE 24: APPS DRIVE DEMAND ============
export const SalesAppsSlide = ({ slide }) => {
  const logos = ['/logos/Parler.svg', '/logos/Pay.svg', '/logos/Cloud.svg', '/logos/Shop.svg', '/logos/Play.svg', '/logos/News.svg'];
  return (
    <SlideWrapper slide={slide} background={
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#030308] via-[#060610] to-[#030308]" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-[#0068ff] opacity-[0.06] blur-[180px] rounded-full" />
      </div>
    }>
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
        <SectionLabel delay={0}>Ecosystem</SectionLabel>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mt-5 mb-3 animate-slide-up">{slide.title}</h2>
        <p className="text-white/40 text-base text-center max-w-2xl mb-8 animate-fade-in" style={{ animationDelay: '0.1s' }}>{slide.subtitle} {slide.description}</p>
        <div className="flex gap-4 mb-8">
          {slide.apps.map((app, idx) => (
            <GlassCard key={idx} delay={0.15 + idx * 0.06} className="px-4 py-3 flex items-center gap-2.5" style={{ borderColor: 'rgba(0,104,255,0.15)' }}>
              <img src={logos[idx]} alt={app} className="w-8 h-8 rounded-lg" />
              <span className="text-white/70 text-xs font-medium">{app}</span>
            </GlassCard>
          ))}
        </div>
        <GlassCard delay={0.5} className="px-6 py-5 max-w-lg w-full" style={{ borderColor: '#0068ff20' }}>
          <div className="text-[10px] uppercase tracking-widest text-white/25 mb-3">When usage increases</div>
          <div className="space-y-2">
            {slide.flywheel.map((f, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold" style={{ background: '#0068ff15', color: '#0068ff' }}>{i + 1}</div>
                <span className="text-white/60 text-sm">{f}</span>
              </div>
            ))}
          </div>
        </GlassCard>
        <GlassCard delay={0.65} className="mt-5 px-6 py-2.5" style={{ borderColor: '#0068ff25' }}>
          <span className="text-[#0068ff] font-semibold text-sm">{slide.closing}</span>
        </GlassCard>
      </div>
    </SlideWrapper>
  );
};

// ============ SLIDE 25: LOYALTY COMPARISON ============
export const SalesLoyaltySlide = ({ slide }) => (
  <SlideWrapper slide={slide} background={
    <div className="fixed inset-0 z-0">
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a0308] via-[#060610] to-[#030810]" />
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[400px] h-[500px] bg-[#6b7280] opacity-[0.04] blur-[150px] rounded-full" />
      <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-[400px] h-[500px] bg-[#0068ff] opacity-[0.06] blur-[150px] rounded-full" />
    </div>
  }>
    <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
      <SectionLabel delay={0}>Business Model</SectionLabel>
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mt-5 mb-3 animate-slide-up">{slide.title}</h2>
      <p className="text-white/40 text-base text-center max-w-3xl mb-10 animate-fade-in" style={{ animationDelay: '0.1s' }}>{slide.subtitle}</p>
      <div className="flex items-stretch gap-8 w-full max-w-4xl">
        <GlassCard delay={0.2} className="flex-1 p-8" style={{ borderColor: 'rgba(107,114,128,0.2)' }}>
          <div className="text-center mb-5">
            <svg viewBox="0 0 24 24" className="w-9 h-9 mx-auto mb-2 text-white/30" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" /></svg>
            <span className="text-lg font-bold text-white/60">{slide.left.label}</span>
          </div>
          <div className="space-y-3">
            {slide.left.items.map((item, i) => (
              <div key={i} className="flex items-center gap-3"><span className="text-white/20">-</span><span className="text-white/50 text-sm">{item}</span></div>
            ))}
          </div>
        </GlassCard>
        <div className="flex items-center"><div className="w-10 h-10 rounded-full bg-[#0068ff]/10 border border-[#0068ff]/25 flex items-center justify-center"><svg viewBox="0 0 24 24" className="w-5 h-5 text-[#0068ff]" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg></div></div>
        <GlassCard delay={0.3} className="flex-1 p-8" style={{ borderColor: '#0068ff30', boxShadow: '0 0 40px rgba(0,104,255,0.08)' }}>
          <div className="text-center mb-5">
            <svg viewBox="0 0 24 24" className="w-9 h-9 mx-auto mb-2 text-[#0068ff]" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
            <span className="text-lg font-bold text-[#0068ff]">{slide.right.label}</span>
          </div>
          <div className="space-y-3">
            {slide.right.items.map((item, i) => (
              <div key={i} className="flex items-center gap-3"><svg viewBox="0 0 24 24" className="w-4 h-4 text-[#0068ff] shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 13l4 4L19 7" /></svg><span className="text-white/60 text-sm">{item}</span></div>
            ))}
          </div>
        </GlassCard>
      </div>
    </div>
  </SlideWrapper>
);
